import BriefcaseIcon from "@assets/svg/BriefcaseIcon";
import dayjs from "@lib/dayjs";
import { Calendar } from "lucide-react";

const interviews = [
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
];

const InterviewMeetingsSection = () => {
  return (
    <div className="flex flex-col flex-1">
      <span className="font-bold text-charcoal text-sm">
        Interviews/Meetings
      </span>
      {/* List Section */}
      <div className="mt-5 flex flex-col gap-5 min-h-0 overflow-y-scroll no-scrollbar">
        {interviews?.map((interview, interviewIndex) => {
          return (
            <div key={interviewIndex} className="flex items-center gap-3.5">
              <div className="flex items-center justify-center w-11 h-11 rounded-md bg-gray-100">
                <Calendar className="w-5 h-5" />
              </div>
              <div className="flex flex-col justify-between flex-1 gap-2">
                <span className="text-xs text-light-black">
                  {interview?.title}
                </span>
                <span className="text-xs font-medium">{interview?.timing}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InterviewMeetingsSection;
